import React,{useState} from "react";
import { useDispatch } from "react-redux";
import {clientAppUserOTPLogin  } from "../../../store/actions/User";

import Loading from "../../Loading/Loading";

import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useSelector } from "react-redux";
// import { useHistory } from "react-router-dom/cjs/react-router-dom";
import './loginSignUpT1.css'
import {  Link  } from "react-router-dom";
const ResetPasswordT1 = ()=>{

 const dispatch = useDispatch();
  
 const handleMouseEnter = () =>dispatch({
  type: "CURSOR",
  
  payload:true
});
const handleMouseLeave = () => dispatch({
  type: "CURSOR",
  
  payload:false
});
    const loginSignUpPopUp = useSelector((state)=>state?.app?.loginSignUpPopUp);
  
     const [loginPopUp , setLoginPopUp] =useState(true);
  const history = useHistory();
 
 const [loader , setLoader] =useState({status:false});
 const [ResetPassword, setResetPassword] = useState({userEmail:''
 
});




/* Handle Signup Function */
const handleResetPassword=(e)=>{
  e.preventDefault();
//console.log(signup)

setLoader({status:true});
  const user = dispatch(clientAppUserOTPLogin (ResetPassword));
  /* get response as Promise   */
  user.then(response => {
   console.log(response)
    if(response){
      dispatch({
        type: "LoginSignUpPopUp",
        
        payload:"resetPassOTP"
      })
    

    }else{
      // alert("no response")

    }
    ;
   

/* resetting Login input Fields */

setResetPassword({userEmail:''

})

setLoader({status:false});


//history.push('/dashboard/profile');


  }).catch(error => {
    
/* resetting Login input Fields */
setResetPassword({userEmail:''

})
setLoader({status:false});
    console.error(error);
  });
 
  }

    return <>
    
{<>

{<Loading  Load={loader?.status}/>}
  <form onSubmit={handleResetPassword} >{loginSignUpPopUp=="resetPassword"?<div onClick={() => dispatch({
    type: "LoginSignUpPopUp",
    
    payload:""
  })}  className="cm_theme1_login-signup-backgropj"></div>:""} <div  className="cm_theme1_login-signup-card"><div  className="blank"> </div>
  <div  className="cm_theme1_login-signup-card-outerj"><div  className="cm_theme1_login-signup-inner">
  <div  className="cm_theme1_blankRight cm_theme1_login-signup-right-signup">
      <div>   <div  className="flex-space-between">  <div  style={{width:"240px",padding:"15px",borderRadius:"15px",marginTop:"10px"}}><img style={{width:"100%"}}
            alt="logo" src="https://i.postimg.cc/7Zwy3WW9/Testprism_Logo.png"/> </div>
     
           </div>
           
     <h3  style={{textAlign:"center"}}>App Tag Line</h3>
     <div className="logo-box-shadow">
     <div className=""  style={{padding:'10px',color:"#222",fontSize:'22px',textAlign:"center"}}> Login Or SignUp With Ease   </div>
        <div  className=""  style={{padding:'10px',color:"#666",fontSize:'15px',textAlign:"center"}}>
        Login Or SignUp With Ease And Access Your Courses   . </div>
        
            <div > 
            <div className="cm_theme1_Login-bottom">
           {loginPopUp?<div  onMouseEnter={handleMouseEnter}
                               onMouseLeave={handleMouseLeave} 
                              onClick={() => dispatch({
                                type: "LoginSignUpPopUp",
                                
                                payload:"signUp"
                              })} className="cm_theme1_course-btn-green-two" style={{fontSize:"16px",
                              }}>
                               Sign Up Here
                              </div>:<Link to="./signup">
                                <div  onMouseEnter={handleMouseEnter}
                               onMouseLeave={handleMouseLeave} className="cm_theme1_course-btn-green-two"
                                style={{fontSize:"16px"}}>
                               Sign Up Here
                              </div> </Link>} {loginPopUp?<div
                     onClick={() => dispatch({
                       type: "LoginSignUpPopUp",
                       
                       payload:"login"
                     })} className="cm_theme1_course-btn-green" style={{fontSize:"16px",}}>
                      Login Here.
                     </div>:<Link to="./login">
                 <div className="ikcraft_course-btn-green" style={{fontSize:"16px"}}>
                Login Here.
               </div> </Link>}</div></div></div></div> 
    </div>  <div  className="cm_theme1_login-signup-left-signup ">
      <h1 style={{"textAlign":"center"}}> Reset Password </h1>
      
 <div  className="cm_theme1_login-input-card "  style={{marginTop:"50px"}}>
 <input onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}  className="cm_theme1_input-textbox" required placeholder="Email" type="text"
  name="userEmail" value={ResetPassword.userEmail} 
  onChange={(e)=>setResetPassword({...ResetPassword, userEmail : e.target.value})} />
   </div>
	  
   
   
    
   
     
   
	
	<div  className="cm_theme1_login-input-card">
   
  <button onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}   className="cm_theme1_login-signup-button" type="submit" id="signupBtn">Send Reset OTP To Email </button>
      
  </div>
<div style={{padding:'5px',fontSize:'18px',color:'#99cc99',textAlign:'center'}} > OR </div>
{loginSignUpPopUp=="resetPassword"?<div  className="cm_theme1_login-input-card">
   
   <button onClick={() => dispatch({
       type: "LoginSignUpPopUp",
       
       payload:"loginWithOTP"
     })}  onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}   className="cm_theme1_login-signup-button-two" type="submit" id="signupBtn">Login With OTP </button>
       
   </div>:<Link to="./loginWithOTP">
  <div  className="cm_theme1_login-input-card">
   
  <button   onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}   className="cm_theme1_login-signup-button-two" type="submit" id="signupBtn">Login With OTP </button>
      
  </div></Link>}
 
 </div>
    
    
  </div></div><div></div></div>
   </form>
</>}
    </>

}
export default ResetPasswordT1;